import i18n from '@/lib/language'
export const formatDate = (time) => {
  if (time) {
    let date = isNumber(time) ? new Date(time * 1000) : time
    const MAX = 9
    date.setFullYear(date.getFullYear())
    let year = date.getFullYear()
    let month = date.getMonth() + 1 > MAX ? date.getMonth() + 1 + '' : '0' + (date.getMonth() + 1)
    let day = date.getDate() > MAX ? date.getDate() + '' : '0' + date.getDate()
    let hours = date.getHours() > MAX ? date.getHours() + '' : '0' + date.getHours()
    let minutes = date.getMinutes() > MAX ? date.getMinutes() + '' : '0' + date.getMinutes()
    let seconds = date.getSeconds() > MAX ? date.getSeconds() + '' : '0' + date.getSeconds()
    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
  } else {
    return '--'
  }
}

export const isNumber = (val) => {
  var regPos = /^\d+(\.\d+)?$/ // 非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true
  } else {
    return false
  }
}

// 检查级联选择器是否选择到人
export const isSelectedUser = (rule, value, callback) => {
  const vLen = value.length
  if (vLen === 0) {
    callback()
  } else {
    for (let i = 0; i < vLen; i++) {
      let item = value[i]
      if (item.includes('userid')) {
        callback()
      }
      if (i === vLen - 1) {
        callback(new Error(i18n.t('message["889"]')))
      }
    }
  }
}

// 格式化开发人员、团队、组
export const formatDeveloper = (info) => {
  const { rolename, groupname } = info
  let aPermission = [rolename, groupname].filter(item => item !== '')
  let str = `${aPermission.join('/')}`
  if (str === '') return '--'
  let sContent = `[${str}]`
  return sContent
}
// 格式化时间戳
export const formatUpTime = (time, type = 1) => {
  if (time) {
    const aDate = formatDate(time).split(' ')
    if (type === 1) {
      return aDate[0]
    } else {
      return aDate[1]
    }
  } else {
    return '--'
  }
}

export const formatField = (data) => {
  if (!data || data === '') {
    return '--'
  }
  return data
}

// 计算提交转化率
export const calculateRate = (mole, deno) => {
  if (deno === 0) return '--'
  let result = 0
  result = (Math.round((mole / deno) * 100))
  return result === 0 ? result : `${result}%`
}

// 防止浏览器拦截新窗口
export const windowOpen = (url, target) => {
  let a = document.createElement('a')
  a.setAttribute('href', url)
  if (target == null) {
    target = ''
  }
  a.setAttribute('target', target)
  document.body.appendChild(a)
  if (a.click) {
    a.click()
  } else {
    try {
      let evt = document.createEvent('Event')
      a.initEvent('click', true, true)
      a.dispatchEvent(evt)
    } catch (e) {
      window.open(url)
    }
  }
  document.body.removeChild(a)
}

export const isObject = (o) => {
  return Object.prototype.toString.call(o) === '[object Object]'
}
